import React from 'react';

import Logo from 'images/logo.svg';

const Header = () => (
  <header className="header-section">
    <div className="sticky-bar">
      <div className="sticky-bar__inner">
        <div className="wrapper">
          <div className="header-center text-align-center">
            <a className="logo-block" title="Dealpay">
              <img src={Logo} alt="Dealpay" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js